import { isDefined } from '@belong/type-utils';
import { Entry, IElementFeatureRow, ILinkItem } from '@belong/types';
import { FElementFeatureRow, isEntryElementFeatureRow } from './elements';
import { FLinkListItem, isEntryLinkListItem } from './molecules';
import { FReadOnlyRow, IEntryReadyOnlyRow, IReadOnlyRow, isEntryReadyOnlyRow } from './readOnlyRow.factory';

interface IEntryCollectionGeneric {
  title?: string;
  collection: Array<Entry<IEntryReadyOnlyRow> | Entry<any>>;
}

type CollectionOptions = IElementFeatureRow | ILinkItem | IReadOnlyRow;
export interface ICollectionGeneric<T extends CollectionOptions = CollectionOptions> {
  title?: string;
  collection: Array<T>;
}

export interface ICollectionGenericWithTitle<T extends CollectionOptions = CollectionOptions> {
  title: string;
  collection: Array<T>;
}

const FCollection = (collection: IEntryCollectionGeneric['collection']): ICollectionGeneric['collection'] =>
  collection
    .map(entry => {
      if (isEntryLinkListItem(entry)) {
        return FLinkListItem(entry);
      }

      if (isEntryElementFeatureRow(entry)) {
        return FElementFeatureRow(entry);
      }

      if (isEntryReadyOnlyRow(entry)) {
        return FReadOnlyRow(entry);
      }

      return undefined;
    })
    .filter(isDefined);

export const FCollectionGeneric = (data: Entry<IEntryCollectionGeneric>): ICollectionGeneric => {
  const { title, collection } = data.fields;
  return {
    title,
    collection: FCollection(collection)
  };
};
